import React, {useEffect, useState} from "react";
import Structure from "../../assets/structure.png";
import CommonSection from "../../components/Layout/CommonSection";
import {useSelector} from "react-redux";
import axios from "axios";
import {baseUrl} from "../../redux/actions/actions";

export default function OrgStructure() {
	const {location} = useSelector((state) => state.location);

	const [loader, setLoader] = useState(false)
	const [image, setImage] = useState(null)

	useEffect(() => {
		fetchStructure().then()
	}, [])

	const fetchStructure = async () => {
		setLoader(true)
		try {
			const response = await axios.get(`${baseUrl}/structure`)
			setImage(response.data?.file)
			setLoader(false)
		} catch (e) {
			setLoader(false)
			console.log(e)
		}
	}

	return (
		<section>
			<CommonSection
				title={location === "uz" ? "Tashkiliy tuzilma" : location === "ru" ? "Структура" : "Organizational structure"}
				breadCrumb={location === "uz" ? "Tashkiliy tuzilma" : location === "ru" ? "Структура" : "Organizational structure"}
			/>

			<div className="container mx-auto py-5 flex justify-center">
				<div className="mx-auto w-full">
					{loader ?
						<p>Loading...</p>
						:
						(
							<>
								<img
									className="w-full py-5"
									src={image}
									alt="organization structure"
								/>
							</>
						)
					}
				</div>
			</div>
		</section>
	);
}
